import { render, staticRenderFns } from "./ResourceBar.vue?vue&type=template&id=58242cf7&scoped=true&"
import script from "./ResourceBar.vue?vue&type=script&lang=js&"
export * from "./ResourceBar.vue?vue&type=script&lang=js&"
import style0 from "./ResourceBar.vue?vue&type=style&index=0&id=58242cf7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58242cf7",
  null
  
)

export default component.exports